import { cloneDeep } from 'lodash'

import { Colors, Services, regExp } from '@sigma-frontend-libs/commons'
import { SENDING_STATUS } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, labelModes, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import info from '@/components/info'
import rulesTemplate from '@/components/rules/template'
import { ruleTags, ruleTypes } from '@/components/rules/utils'
import senderNameToIds from '@/components/services/providers/senderNameToIds'
import userApiKeys from '@/components/services/providers/userApiKeys'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderTitle(h, { key }) {
  const property = this.properties.find(item => {
    return item.property === key
  })
  const item = Object.assign({}, { title: key }, cloneDeep(property))

  return h(
    'div',
    {
      class: 'properties-title'
    },
    [
      h(
        textOverflow,
        {
          props: {
            value: item.title
          }
        }
      ),
      h(
        'div',
        {
          class: 'properties-title-description'
        },
        [ item.description ]
      )
    ]
  )
}
function renderValue(h, item) {
  let label = item.value
  switch (item.key) {
    case 'telegramGateway_apiTokens':
    case 'd360ApiKeys':
    case 'teleleo_apiKeys': {
      label = Object.keys(item.value).length
      break
    }
    case 'forceMessageStatus': {
      label = undefined
      if (item.value.status) {
        label = this.getTranslate(`${Services.sendings}.statuses.${item.value.status}`)
      }
      break
    }
    case 'megafonTarget_campaignTimeWindowHrs': {
      label = item.value.join(' - ')
      break
    }
    case 'megafonTarget_senderNameToIds': {
      return
    }
  }

  return h(
    'div',
    {
      class: 'properties-value'
    },
    [
      h(
        tag,
        {
          props: {
            label,
            size: sizes.tiny,
            color: Colors.primary
          }
        }
      )
    ]
  )
}
function renderRemoveButton(h, index) {
  return h(
    button,
    {
      class: { 'hover-child': this.viewport.breakpoint.mdUp },
      props: {
        icon: icons.remove,
        mode: buttonModes.flat,
        color: Colors.error
      },
      on: {
        click: () => {
          this.removeField(index)
        }
      }
    }
  )
}
function renderItemBody(h, item, index) {
  return h(
    'div',
    {
      class: 'properties-item-body hover-background',
      on: {
        click: () => {
          this.edit(index)
        }
      }
    },
    [
      renderTitle.call(this, h, item),
      renderValue.call(this, h, item, index)
    ]
  )
}
function renderItem(h, item, index) {
  return h(
    'div',
    {
      class: 'properties-item hover-parent hover-parent--opacity'
    },
    [
      renderItemBody.call(this, h, item, index),
      renderRemoveButton.call(this, h, index)
    ]
  )
}
function renderItems(h) {
  if (Array.isArray(this.proxy) && this.proxy.length) {
    return h(
      'div',
      {
        class: 'properties-list'
      },
      [
        this.proxy.map((item, index) => {
          return renderItem.call(this, h, item, index)
        })
      ]
    )
  } else {
    return h(
      'div',
      {
        class: 'properties-empty'
      },
      [
        h(
          squircle,
          {
            props: {
              icon: icons.search_off,
              color: Colors.grey,
              size: sizes.medium
            }
          }
        ),

        h(
          'div',
          {
            class: 'properties-empty-text'
          },
          [
            h(
              'div',
              {
                class: 'properties-empty-title'
              },
              [ this.getTranslate(`${Services.providers}.titles.properties.notFound`) ]
            ),
            h(
              'div',
              {
                class: 'properties-empty-hint'
              },
              [ this.getTranslate(`${Services.providers}.hints.properties.notFound`) ]
            )
          ]
        )
      ]
    )
  }
}

function renderKeyField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.payload.key,
        label: this.getTranslate('misc.key'),
        hint: this.hint,
        items: this.properties.filter(this.propertiesFilter).map(item => {
          return {
            title: item.property,
            value: item.property,
            group: item.group,
            description: item.description
          }
        }),
        itemsDisabled: this.proxy.map(({ key }) => {
          return key
        }),
        searchValidation: this.searchValidator,
        loading: this.propertiesLoading,
        disabled: !this.$_processor || this.propertiesLoading,
        labelMode: labelModes.outline,
        dense: true,
        combobox: true,
        autocomplete: true
      },
      on: {
        input: event => {
          this.payload.key = event
        }
      },
      scopedSlots: {
        item: ({ item }) => {
          return renderTitle.call(this, h, { key: item.title }, true)
        }
      }
    }
  )
}
function renderValueField(h) {
  if (this.payload.key) {
    const { type, property } = this._getProperty()
    let mask
    if (type === 'number') {
      mask = /^\d+$/
    }
    if (property === 'failurePercent') {
      mask = regExp.percentage
    }
    switch (type) {
      case 'boolean': {
        return h(
          components.switch,
          {
            props: {
              label: this.getTranslate(`misc.${this.payload.value}`),
              value: this.payload.value,
              outline: true
            },
            on: {
              input: event => {
                this.payload.value = event
              }
            }
          }
        )
      }
      default: {
        switch (property) {
          case 'telegramGateway_apiTokens':
          case 'd360ApiKeys':
          case 'teleleo_apiKeys': {
            return h(
              userApiKeys,
              {
                props: {
                  value: this.payload.value
                },
                on: {
                  input: event => {
                    this.payload.value = event
                  }
                }
              }
            )
          }

          case 'forceMessageStatus': {
            return h(
              'div',
              {
                class: 'properties-field-status'
              },
              [
                h(
                  components.select,
                  {
                    props: {
                      value: this.payload.value.status,
                      label: this.getTranslate(`${Services.sendings}.labels.status`),
                      items: SENDING_STATUS.map(status => {
                        return {
                          title: this.getTranslate(`${Services.sendings}.statuses.${status}`),
                          value: status
                        }
                      }),
                      dense: true,
                      clearable: true,
                      details: false
                    },
                    on: {
                      input: event => {
                        this.payload.value.status = event
                      }
                    }
                  }
                ),
                h(
                  rulesTemplate,
                  {
                    props: {
                      value: this.payload.value.conditions,
                      whitelist: [ ruleTags.mccmnc ],
                      ruleType: ruleTypes.conditions
                    },
                    on: {
                      input: event => {
                        this.payload.value.conditions = event
                      }
                    }
                  }
                )
              ]
            )
          }

          case 'megafonTarget_campaignTimeWindowHrs': {
            const hourRegExp = /^([01]?[0-9]|2[0-4])$/

            return h(
              'div',
              {
                class: 'properties-field-hours'
              },
              [
                h(
                  components['text-field'],
                  {
                    props: {
                      value: this.payload.value[0],
                      label: this.getTranslate('misc.measure.time.from'),
                      hint: this.getTranslate('misc.hints.from0To24'),
                      suffix: this.getTranslate('misc.measure.time.short.hours'),
                      labelMode: labelModes.outline,
                      dense: true,
                      clearable: true,
                      mask: hourRegExp
                    },
                    on: {
                      input: event => {
                        this.$set(this.payload.value, 0, event)
                      }
                    }
                  }
                ),

                h(
                  components['text-field'],
                  {
                    props: {
                      value: this.payload.value[1],
                      label: this.getTranslate('misc.measure.time.to'),
                      hint: this.getTranslate('misc.hints.from0To24'),
                      suffix: this.getTranslate('misc.measure.time.short.hours'),
                      labelMode: labelModes.outline,
                      dense: true,
                      clearable: true,
                      mask: hourRegExp
                    },
                    on: {
                      input: event => {
                        this.$set(this.payload.value, 1, event)
                      }
                    }
                  }
                )
              ]
            )
          }

          case '_testPayloadText': {
            return h(
              components.textarea,
              {
                props: {
                  value: this.payload.value,
                  label: this.getTranslate('misc.value'),
                  labelMode: labelModes.outline,
                  dense: true,
                  clearable: true,
                  details: false
                },
                on: {
                  input: event => {
                    this.payload.value = event
                  }
                }
              }
            )
          }

          case 'megafonTarget_senderNameToIds': {
            return h(
              senderNameToIds,
              {
                props: {
                  value: this.payload.value
                },
                on: {
                  input: event => {
                    this.payload.value = event
                  }
                }
              }
            )
          }

          default: {
            return h(
              components['text-field'],
              {
                props: {
                  value: this.payload.value,
                  label: this.getTranslate('misc.value'),
                  labelMode: labelModes.outline,
                  dense: true,
                  clearable: true,
                  autofocus: true,
                  details: false,
                  mask
                },
                on: {
                  input: event => {
                    this.payload.value = event
                  }
                }
              }
            )
          }
        }
      }
    }
  }
}
function renderWarning(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.providers}.warnings.server`),
        color: Colors.error
      }
    }
  )
}
function renderDialogBody(h) {
  const content = []
  if (!this.$_processor) {
    content.push(renderWarning.call(this, h))
  } else {
    content.push(renderKeyField.call(this, h))
    content.push(renderValueField.call(this, h))
  }

  return h(
    'div',
    {
      class: 'properties-dialog-body'
    },
    content
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'properties-dialog-footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            label: this.getTranslate('misc.buttons.cancel')
          },
          on: {
            click: () => {
              this.cancel()
            }
          }
        }
      ),

      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            color: Colors.primary,
            label: this.getTranslate('misc.buttons.save'),
            disabled: this.disabled
          },
          on: {
            click: () => {
              if (this.editMode) {
                this.update()
              } else {
                this.add()
              }
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let titleAction = 'add'
  if (this.editMode) {
    titleAction = 'edit'
  }

  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.providers}.titles.properties.${titleAction}`),
        value: this.showDialog,
        maxWidth,
        closeOnClick: false
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'properties-footer'
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.add,
            mode: buttonModes.flat,
            color: Colors.primary,
            label: this.getTranslate(`${Services.providers}.buttons.add.property`)
          },
          on: {
            click: () => {
              this.showDialog = true
            }
          },
          scopedSlots: {
            dialog: () => {
              return renderDialog.call(this, h)
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    components.card,
    {
      class: 'properties-card',
      props: {
        title: this.getTranslate(`${Services.providers}.hints.properties.hint`),
        dashed: true,
        outline: true,
        rounded: true
      }
    },
    [
      renderItems.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
